// A faixa de quadradinhos: um por dia do período, colorido pelo estado que o
// servidor calculou (completo, faltou hora, nada anotado, ausência, hoje…).
// É o jeito de ver de relance ONDE estão os buracos de cada pessoa.
//
// HTML puro e `title` nativo de propósito: são até 93 quadradinhos por pessoa,
// e um Tooltip do antd para cada um pesaria a tabela inteira.
import { LISTRAS_CLOCKIFY, corDoDia, textoDoDia, type DiaPainel } from './painelUtils';

export default function FaixaDias({ dias, cargaDiaMin }: { dias: DiaPainel[]; cargaDiaMin: number }) {
  // Período longo encolhe o quadradinho para a faixa caber na coluna.
  const largura = dias.length > 45 ? 5 : dias.length > 21 ? 9 : 14;
  const altura = 18;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
      {dias.map((d, i) => {
        // Feriado sem hora tem cor própria (13/10/2026); com hora, segue como dia "extra".
        const { fundo, borda } = corDoDia(d);
        // Um respiro antes de cada segunda-feira separa as semanas.
        const [y, m, dd] = d.data.split('-').map(Number);
        const segunda = new Date(Date.UTC(y, m - 1, dd)).getUTCDay() === 1;
        return (
          <span
            key={d.data}
            title={textoDoDia(d, cargaDiaMin)}
            style={{
              display: 'inline-block', width: largura, height: altura, boxSizing: 'border-box',
              marginLeft: i === 0 ? 0 : segunda ? 5 : 2, borderRadius: 2,
              backgroundColor: fundo, border: `1px solid ${borda}`,
              // Listrado = a hora desse dia veio do Clockify (nada no anotador novo).
              backgroundImage: (d.clockify || 0) > 0 ? LISTRAS_CLOCKIFY : undefined,
              // Home office/campo: um tracinho embaixo, sem mudar a cor do dia.
              boxShadow: d.campo ? 'inset 0 -3px 0 #135200' : d.remoto ? 'inset 0 -3px 0 #003eb3' : undefined,
            }}
          />
        );
      })}
    </span>
  );
}
